require("./share");
var ResourceLoader = require("./resource-loader");
$(document).ready(function () {
    var resources = [
        {type: 'img', src: 'images/loading_bg.png'},
        {type: 'img', src: 'images/loading_bi.png'},
        {type: 'img', src: 'images/css_sprites.png'},
        {type: 'img', src: 'images/bg.jpg'},
        {type: 'img', src: 'images/box1.jpg'},
        {type: 'img', src: 'images/box2.jpg'},
        {type: 'img', src: 'images/box3.jpg'},
        {type: 'img', src: 'images/box1-hover.jpg'},
        {type: 'img', src: 'images/box2-hover.jpg'},
        {type: 'img', src: 'images/box3-hover.jpg'},
        {type: 'img', src: 'images/icon1.png'},
        {type: 'img', src: 'images/icon2.png'},
        {type: 'img', src: 'images/icon3.png'},
        {type: 'img', src: 'images/icon4.png'},
        {type: 'img', src: 'images/left-big-word.png'},
        {type: 'img', src: 'images/popup1.png'},
        {type: 'img', src: 'images/popup2.png'},
        {type: 'img', src: 'images/popup3.png'},
        {type: 'img', src: 'images/share-icon.png'},
        {type: 'img', src: 'images/treasure-box.png'},
        {type: 'img', src: 'images/top-logo.png'}
    ];
    var loader = new ResourceLoader(resources);
    loader.onResourceReady = function () {
        var curProcess = parseInt((this.finished / this.resources.length) * 100) + "%";
        $('.loading2').css("height", curProcess);
        $('.loading').remove();
        $('.main-left1').fadeIn(function () {
            $('.main-left2').fadeIn(function () {
                $('.main-right').fadeIn()
            })
        })
    };
    loader.load();
    $('.main-right div').click(function () {
        var index = $(this).index();
        $('.popup').show();
        $('.popup div').eq(index).fadeIn().siblings().fadeOut();
    });
    $('.popup').click(function () {
        $('.popup,.popup div').hide();
    });
});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0